import PropTypes from 'prop-types'

const CalendarSquare = ({
  width = '24',
  height = '24',
  className = '',
  color = '#7A858C',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    {...{ ...props }}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icons/calendar">
      <g id="Vector">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.5 5.5C4.94772 5.5 4.5 5.94772 4.5 6.5V20.5C4.5 21.0523 4.94772 21.5 5.5 21.5H19.5C20.0523 21.5 20.5 21.0523 20.5 20.5V6.5C20.5 5.94772 20.0523 5.5 19.5 5.5H5.5ZM2.5 6.5C2.5 4.84315 3.84315 3.5 5.5 3.5H19.5C21.1569 3.5 22.5 4.84315 22.5 6.5V20.5C22.5 22.1569 21.1569 23.5 19.5 23.5H5.5C3.84315 23.5 2.5 22.1569 2.5 20.5V6.5Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5 1.5C17.0523 1.5 17.5 1.94772 17.5 2.5V6.5C17.5 7.05228 17.0523 7.5 16.5 7.5C15.9477 7.5 15.5 7.05228 15.5 6.5V2.5C15.5 1.94772 15.9477 1.5 16.5 1.5Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.5 1.5C9.05228 1.5 9.5 1.94772 9.5 2.5V6.5C9.5 7.05228 9.05228 7.5 8.5 7.5C7.94772 7.5 7.5 7.05228 7.5 6.5V2.5C7.5 1.94772 7.94772 1.5 8.5 1.5Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 10.5C2.5 9.94771 2.94772 9.5 3.5 9.5H21.5C22.0523 9.5 22.5 9.94771 22.5 10.5C22.5 11.0523 22.0523 11.5 21.5 11.5H3.5C2.94772 11.5 2.5 11.0523 2.5 10.5Z"
          fill={color}
        />
      </g>
    </g>
  </svg>
)

CalendarSquare.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
}

CalendarSquare.defaultProps = {
  width: '24',
  height: '24',
  className: '',
}

export default CalendarSquare
